import { CSSProperties, ReactNode } from 'react';
import { List as MUIList, ListProps as MUIListProps } from '@mui/material';

import ListItem from './ListItem';
import ListItemButton from './ListItemButton';
import ListItemText from './ListItemText';

type AtomMUIProps = {
  children?: ReactNode;
  disablePadding?: boolean;
  style?: CSSProperties;
};

export type ListProps = AtomMUIProps;

export const List = (props: ListProps) => {
  const MUIProps: MUIListProps = props;

  return <MUIList {...MUIProps} />;
};

List.ListItem = ListItem;
List.ListItemButton = ListItemButton;
List.ListItemText = ListItemText;

export default List;
